/* istanbul ignore file */
export { default } from './GoogleReviews';
